export default "__VITE_ASSET__ogkaNTpy__"